import { request } from "../_helpers/Auth";

const namespace = "/api";

export const setupIntent = () => {
    return request({
        url: namespace + "/setup_intent",
        method: "get",
    });
};

export const addPaymentMethod = (payload) => {
    return request({
        url: namespace + "/add_payment_method",
        method: "post",
        data: payload,
    });
};
